import type { TemplateWebMCPToolResult } from '../responses';

const ID_FIELDS = ['effectId', 'presetId', 'targetId'] as const;

function readId(value: unknown): string | undefined {
  return typeof value === 'string' && value.length <= 128 ? value : undefined;
}

/**
 * Identifiers for an animation mutation audit line. Params, keyframes and
 * rendered media are never included.
 */
export function animationAuditFields(
  input: Record<string, unknown>,
  result: TemplateWebMCPToolResult<Record<string, unknown>>,
): Record<string, unknown> {
  const fields: Record<string, unknown> = {};
  for (const field of ID_FIELDS) {
    const value = readId(input[field]);
    if (value !== undefined) {
      fields[field] = value;
    }
  }
  if (!result.structuredContent.ok) {
    return fields;
  }
  const data = result.structuredContent.data;
  const effect = data.effect as Record<string, unknown> | undefined;
  const effectId = readId(effect?.effectId);
  if (effectId !== undefined) {
    fields.effectId = effectId;
  }
  const replaced = Array.isArray(data.replaced)
    ? data.replaced
        .map((entry) => readId((entry as Record<string, unknown>)?.effectId))
        .filter(Boolean)
    : [];
  if (replaced.length > 0) {
    fields.replacedEffectIds = replaced;
  }
  if (data.animationCleared === true) {
    fields.animationCleared = true;
  }
  return fields;
}
